import React, {  useState } from "react";
import {  Container, Tab, Tabs } from "react-bootstrap";
import Addcar from "./addcar";
import Allcar from "./allcar";

import { ToastContainer } from "react-toastify";
const Cars = ({ userData }) => {
  const [carid, setcarid] = useState(false);
  const [key, setKey] = useState("enter");
  const [model, setmodel] = useState("");
  const [cartype, setcartype] = useState("");
  const [chassenumber, setchassenumber] = useState("");
  const [year, setyear] = useState("");
  const [categoryname, setcategoryname] = useState("");
  const [IsEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const [price, setprice] = useState("");
  const [descrip, setdescrip] = useState("");
  const [Videoy, setVideoy] = useState("");
  const [Motor, setMotor] = useState("");
  const [color, setcolor] = useState("");
  const [CarNumber, setCarNumber] = useState("");

  const [images, setImages] = useState([]);
  const [imagesUpdated, setImagesUpdated] = useState([]);
  const [CarImageId, setCarImageId] = useState([]);
  const [CarImageAlll, setCarImageAlll] = useState([]);

  return (
    <div className="tabss">
      <Container>
        <h4 className="text-center mt-3 mb-3">إدارة السيارات</h4>
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="enter" title="إضافة سيارة">
            <Addcar
            setCarNumber={setCarNumber}
            CarNumber={CarNumber}
            setcolor={setcolor}
            color={color}
              setVideoy={setVideoy}
              Videoy={Videoy}
              Motor={Motor}
              setMotor={setMotor}
              CarImageAlll={CarImageAlll}
              setCarImageAlll={setCarImageAlll}
              imagesUpdated={imagesUpdated}
              setImagesUpdated={setImagesUpdated}
              setCarImageId={setCarImageId}
              CarImageId={CarImageId}
              setisPress={setisPress}
              isPress={isPress}
              setImages={setImages}
              images={images}
              setdescrip={setdescrip}
              descrip={descrip}
              setprice={setprice}
              price={price}
              key={key}
              setKey={setKey}
              loading={loading}
              setLoading={setLoading}
              carid={carid}
              setcarid={setcarid}
              setIsEdit={setIsEdit}
              IsEdit={IsEdit}
              setcategoryname={setcategoryname}
              categoryname={categoryname}
              setyear={setyear}
              year={year}
              setchassenumber={setchassenumber}
              chassenumber={chassenumber}
              setcartype={setcartype}
              cartype={cartype}
              model={model}
              setmodel={setmodel}
            />
          </Tab>
          <Tab eventKey="display" title="عرض السيارات">
            <Allcar
                   setcolor={setcolor}
                   color={color}
              setVideoy={setVideoy}
              Videoy={Videoy}
              Motor={Motor}
              setCarNumber={setCarNumber}
              CarNumber={CarNumber}
              setMotor={setMotor}
              CarImageAlll={CarImageAlll}
              setCarImageAlll={setCarImageAlll}
              imagesUpdated={imagesUpdated}
              setImagesUpdated={setImagesUpdated}
              setCarImageId={setCarImageId}
              CarImageId={CarImageId}
              setisPress={setisPress}
              isPress={isPress}
              setImages={setImages}
              images={images}
              userData={userData}
              setdescrip={setdescrip}
              descrip={descrip}
              setprice={setprice}
              price={price}
              key={key}
              setKey={setKey}
              loading={loading}
              setLoading={setLoading}
              setIsEdit={setIsEdit}
              carid={carid}
              setcarid={setcarid}
              IsEdit={IsEdit}
              setcategoryname={setcategoryname}
              categoryname={categoryname}
              setyear={setyear}
              year={year}
              setchassenumber={setchassenumber}
              chassenumber={chassenumber}
              setcartype={setcartype}
              cartype={cartype}
              model={model}
              setmodel={setmodel}
            />
          </Tab>
          {/* <Tab eventKey="req" title="الطلبات">
            <Reqcar />
          </Tab> */}
        </Tabs>
      </Container>
      <ToastContainer />
    </div>
  );
};

export default Cars;
